import { Modal } from "antd"
import { useResendInvoice } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"

export const useResendInvoiceModal = (
  invoiceUuid: string,
  onSuccess?: () => void
) => {
  const [modal, contextHolder] = Modal.useModal()
  const resendMutation = useResendInvoice(invoiceUuid)

  const showResendInvoiceModal = (): void => {
    modal.confirm({
      title: "Resend Invoice Email",
      content:
        "Are you sure you want to resend the invoice notification email to the member on file?",
      okText: "Resend Email",
      cancelText: "Cancel",
      onOk: () =>
        new Promise<void>((resolve, reject) => {
          resendMutation.mutate(undefined, {
            onSuccess: () => {
              message.success("Invoice email has been resent")
              onSuccess?.()
              resolve()
            },
            onError: (error) => {
              message.error(`Failed to resend invoice email: ${error.message}`)
              reject()
            },
          })
        }),
    })
  }

  return {
    contextHolder,
    showResendInvoiceModal,
  }
}
